import { useCurrentUser } from "@internal/plugin-utilities";
import { Entity } from "@backstage/catalog-model";

export const useIsAdmin = (): boolean => {
  const currentUser = useCurrentUser() as Entity;
  const adminAnnotation =
    currentUser?.metadata.annotations?.["kajabi.com/radiator.admin"];
  if (currentUser && adminAnnotation && adminAnnotation === "true") {
    return true;
  }
  return false;
};
